// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row_even{background-color:#fff!important}.row_selected{background-color:#cfd8dc!important}", ""]);
// Exports
module.exports = exports;
